import axios from 'axios';

export const DEFAULT_STORE_BACKGROUND_PROMPT = 'A wide aisle of a modern supermarket beverage section with fully stocked shelves, a polished floor and bright, even lighting.';

export function fitStoreBackgroundToCanvas(object) {
  const canvas = object?.canvas;
  if (!canvas || !object.width || !object.height) return false;

  const zoom = canvas.getZoom?.() || 1;
  const width = canvas.width / zoom;
  const height = canvas.height / zoom;
  const scale = Math.max(width / object.width, height / object.height);

  object.set({
    originX: 'center', originY: 'center',
    left: width / 2, top: height / 2,
    scaleX: scale, scaleY: scale,
    angle: 0, skewX: 0, skewY: 0,
  });
  object.setCoords();
  return true;
}

function waitForPoll(signal) {
  return new Promise((resolve, reject) => {
    const abort = () => {
      clearTimeout(timer);
      reject(new DOMException('Generation cancelled', 'AbortError'));
    };
    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', abort);
      resolve();
    }, 5000);
    signal?.addEventListener('abort', abort, { once: true });
    if (signal?.aborted) abort();
  });
}

export async function generateStoreBackgroundImage({ prompt, layoutId, instanceId, signal }, {
  client = axios, wait = waitForPoll, maxAttempts = 120,
} = {}) {
  const { data: job } = await client.post('/banner/groups/generate_image', {
    prompt, layout_id: layoutId, layout_template_id: instanceId,
    function: 'gpt_image_1_generate', number_of_images: 1,
    isSingleRender: true,
  }, { signal });

  if (!job?.uuid || job.error) throw new Error(job?.error || 'Could not start image generation');

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    signal?.throwIfAborted();
    const { data: result } = await client.get(`/banner/groups/check_image_generation_job/${job.uuid}`, { signal });
    if (result.error) throw new Error(result.error);
    if (result.done) {
      const urls = typeof result.image_urls === 'string'
        ? JSON.parse(result.image_urls)
        : result.image_urls;
      if (!urls?.[0]) throw new Error('Image generation finished without an image');
      return urls[0];
    }
    await wait(signal);
  }
  throw new Error('Image generation is taking too long. Please try again.');
}
